export const ButtonFloatingComponent = {
  bindings: {
    icon: '@',
  },
  transclude: true,
  templateUrl: 'components/Buttons/button-floating/button-floating.html',
};
